var gql = require("graphql-tag");

const CHECK_PROVIDER_ADDRESS_QUERY = gql`
    query CHECK_PROVIDER_ADDRESS_QUERY($address_id: Int!, $provider_id: Int) {
        checkProviderAddress(
            address_id: $address_id
            provider_id: $provider_id
        ) {
            current_provider
            any_provider
            all_tariffs
        }
    }
`;

export default CHECK_PROVIDER_ADDRESS_QUERY;
